// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HzO_","icon":"styles_icon__1qw_u"};